(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-youtube-video-cover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-youtube-video-cover')) {
    class PdpYoutubeVideoCover extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.button = this.querySelector('.pdp-yt-cover__play');
        this.embedSrc = this.dataset.embedSrc;

        if (!this.button || !this.embedSrc) return;

        this.initialized = true;
        this.iframe = null;
        this.restoreOnPause = this.dataset.restoreOnPause === 'true';
        this.playerOrigin = new URL(this.embedSrc).origin;

        this.button.addEventListener('click', () => this.play());
        window.addEventListener('message', (event) => this.handleMessage(event));
        // Drop the player before leaving so history restoration or bfcache never resumes it hidden with audio
        window.addEventListener('pagehide', () => this.restoreCover({ focus: false }));
      }

      play() {
        if (this.iframe) return;

        // Built on demand: an iframe whose src was swapped gets its autoplay URL restored on back navigation
        const iframe = document.createElement('iframe');
        iframe.className = 'pdp-yt-cover__iframe';
        iframe.title = this.dataset.title || '';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.addEventListener('load', () => this.startListening());
        iframe.src = this.embedSrc;

        this.iframe = iframe;
        this.append(iframe);
        this.classList.add('is-playing');
        iframe.focus({ preventScroll: true });
      }

      restoreCover({ focus = true } = {}) {
        this.classList.remove('is-playing');

        if (this.iframe) {
          this.iframe.remove();
          this.iframe = null;
        }

        if (focus) this.button.focus({ preventScroll: true });
      }

      startListening() {
        if (!this.iframe) return;

        this.iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }),
          this.playerOrigin
        );
      }

      handleMessage(event) {
        if (event.origin !== this.playerOrigin) return;
        if (!this.iframe || event.source !== this.iframe.contentWindow) return;

        let payload;

        try {
          payload = JSON.parse(event.data);
        } catch (error) {
          return;
        }

        if (payload.event !== 'onStateChange' && payload.event !== 'infoDelivery') return;

        const state = typeof payload.info === 'number' ? payload.info : payload.info && payload.info.playerState;

        if (typeof state !== 'number') return;

        if (state === 0 || (state === 2 && this.restoreOnPause)) {
          this.restoreCover();
        }
      }
    }

    customElements.define('pdp-youtube-video-cover', PdpYoutubeVideoCover);
  }
  } catch(e) { console.error(e); }
})();

})();
